/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useLocalization } from "@lemmonhq/uikit";

/**
 * The account area's loyalty tab. The real view lives at `/collected`, which is
 * also where the claim funnel lands — one page rather than two that drift.
 */
export const LoyaltySubpage = defineComponent({
  setup() {
    const { t } = useLocalization();
    const router = useRouter();

    onMounted(() => {
      router.replace("/collected");
    });

    return () => (
      <div class="flex flex-col items-center justify-center py-16 gap-3 text-base-content/50">
        <span class="material-symbols-outlined text-4xl">loyalty</span>
        <p class="text-sm">{t("customer.collected.title")}</p>
      </div>
    );
  },
});
